// extracted by mini-css-extract-plugin
export default {"wrapper":"Kontakt_wrapper__gxaTT","text":"Kontakt_text__Gz3Ef","header":"Kontakt_header__ke+B4","map":"Kontakt_map__kHtEe"};